import React, { useRef, useEffect, useState, useContext } from "react";

import {
  Grid,
  Card,
  FormControl,
  InputLabel,
  OutlinedInput,
  // FilledInput,
  InputAdornment,
  TextField,
  MenuItem,
  Button,
  Typography,
  IconButton,
  Divider,
  Input,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import DeleteIcon from "@material-ui/icons/Delete";
import feedbackContext from "contexts/feedbackContext";
import { notify, closeSnack } from "utils/MyFunctions";
import axios from "axios";
import userContext from "contexts/userContext";
import { formatMessage } from "utils/MyFunctions";
import { useIntl, FormattedMessage } from "react-intl";
import FileUpload from "../../../../FileUpload";
import { read, utils } from "xlsx";
export default function LivePreviewExample(props) {
  const intl = useIntl();
  const requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Accept: "application/ld+json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    feedbackContext,
  );

  const normalizeNumberString = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const n = Number(value);
    return Number.isNaN(n) ? String(value) : String(n);
  };
  const { role, setRole, locale } = useContext(userContext);
  const MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
  const [modeles, setModeles] = React.useState([]);
  const typesC = ["Dry", "Tank", "Reefer", "Open Top", "Flat Rack"];
  const typesCh = ["FCL/FCL", "FCL/LCL", "LCL/LCL", "LCL/FCL"];
  const [init, setInit] = useState([]);

  const NCO20 = props.bescId ? undefined : 0;
  const NCO40 = props.bescId ? undefined : 0;
  const NCH = props.bescId ? undefined : 0;
  const [cCO20, setCCO20] = useState(NCO20);
  const [cCO40, setCCO40] = useState(NCO40);
  const [cCH, setCCH] = useState(NCH);

  const [SH, setSH] = React.useState([]);
  const [received1, setReceived1] = React.useState(false);
  const [received2, setReceived2] = React.useState(false);
  const [received3, setReceived3] = React.useState(false);
  const [received4, setReceived4] = React.useState(false);
  const [hydrated, setHydrated] = React.useState(false);
  const received = received1 && received2 && received3;

  const [openSH, setOpenSH] = React.useState(false);
  const [openM, setOpenM] = React.useState([false]);
  const [codesSH, setCodesSH] = React.useState([]);
  const [fetching, setFetching] = React.useState(false);
  const loadingSH = openSH && fetching;
  const loadingM = openM.includes(true) && fetching;
  const [classesT, setClassesT] = React.useState([]);

  const [valid, setValid] = React.useState(false);

  const [file, setFile] = React.useState();

  useEffect(() => {
    console.log("file changed, file : ", file);
    if (file) {
      let _values = [...detailsChassis];
      _values[file.index]["cartegrise"] = file.file.name;
      _values[file.index]["b64"] = file.file.uuid;
      setDetailsChassis(_values);
    }
  }, [file]);

  const [marchandise, setMarchandise] = React.useState({
    cond:
      role &&
      role.user &&
      role.user.company.consignataire &&
      props.sens === "import"
        ? "ro-ro"
        : "",
    cvalue: "0",
    ccurrency: "USD",
    fvalue: "0",
    fcurrency: "USD",
    nbcont20: "0",
    nbcont40: "0",
    poids: "0",
    volume: "0",
    nbchassis: "0",
    nbmotos: "0",
    nbcolis: "0",
    description: "",
    typeMarchandise: "",
    shcode: "",
  });

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleChangeConteneur = (index, event) => {
    // setReceived2(true);
    console.log("handleChangeConteneur");
    event.persist(event);

    let _details = [...detailsConteneur];
    _details[index][event.target.name] = event.target.value;

    setDetailsConteneur(_details);
  };

  const handleChangeChassis = (index, event) => {
    // setReceived3(true);
    event.persist(event);

    let _details = [...detailsChassis];
    _details[index][event.target.name] = event.target.value;
    setDetailsChassis(_details);
  };

  const handleChangeSH = (index, event) => {
    if (event.target.name === "products" && event.target.value.length > 255) {
      event.preventDefault();
      let _sh = [...SH];
      _sh[index][event.target.name] = event.target.value.substring(0, 255);
      setSH(_sh);
      // event.persist(event);
      // let _sh = [...SH];
      // _sh[index][event.target.name] = event.target.value;
      // setSH(_sh);
    } else {
      event.persist(event);
      let _sh = [...SH];
      _sh[index][event.target.name] = event.target.value;
      setSH(_sh);
    }
  };

  const [detailsConteneur, setDetailsConteneur] = React.useState([]);
  const skipContainerRebuildRef = useRef(false);
  const [errors, setErrors] = React.useState({});
  const [helpers, setHelpers] = React.useState({});

  const [chassisErrors, setChassisErrors] = React.useState({});
  const [chassisHelpers, setChassisHelpers] = React.useState({});

  const [marchandiseErrors, setMarchandiseErrors] = React.useState({});
  const [marchandiseHelpers, setMarchandiseHelpers] = React.useState({});
  const [detailsChassis, setDetailsChassis] = React.useState([]);

  const [filled, setFilled] = useState(false);

  const filter = createFilterOptions();
  const [currencies, setCurrencies] = React.useState([
    { value: "USD", name: "US Dollar" },
  ]);
  const conditionnements = [
    {
      value: "conteneur",
      label: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_container",
      ),
    },
    {
      value: "ro-ro",
      label: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_roro",
      ),
    },
    {
      value: "vrac",
      label: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_bulk",
      ),
    },
    {
      value: "conventionnel",
      label: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_conventional",
      ),
    },
  ];

  useEffect(() => {
    console.log(
      " cCO20 changed , new  cCO20 : ",
      cCO20,
      " typeof cCO20 : ",
      typeof cCO20,
      " prev : ",
      previousCCO20,
    );
  }, [cCO20]);
  useEffect(() => {
    console.log(
      "  cCO40 changed , new   cCO40 : ",
      cCO40,
      " prev : ",
      previousCCO40,
    );
  }, [cCO40]);

  useEffect(() => {
    console.log(" cCH changed , new  cCH : ", cCH, " prev : ", previousCCH);
  }, [cCH]);
  useEffect(() => {
    console.log(
      " received changed , received1 : ",
      received1,
      " received2 : ",
      received2,
      " received3 : ",
      received3,
      " new  received : ",
      received,
    );
  }, [received]);

  useEffect(() => {
    console.log(" received1 changed , received1 : ", received1);
  }, [received1]);
  useEffect(() => {
    console.log(" received2 changed , received2 : ", received2);
  }, [received2]);
  useEffect(() => {
    console.log(" received3 changed , received3 : ", received3);
  }, [received3]);

  const [mtypes, setMtypes] = React.useState([]);
  useEffect(() => {
    setFetching(false);
  }, [modeles]);

  useEffect(() => {
    setFetching(false);
  }, [codesSH]);

  useEffect(() => {
    if (!openSH) {
      setCodesSH([]);
    }
  }, [openSH]);

  const validateValues = () => {
    let _errors = [];
    let _helpers = [];

    let _cerrors = [];
    let _chelpers = [];

    let _marchandiseErrors = {
      cond: "",
      cvalue: "",
      ccurrency: "",
      fvalue: "",
      fcurrency: "",
      nbcont20: "",
      nbcont40: "",
      poids: "",
      volume: "",
      nbchassis: "",
      nbcolis: "",
      description: "",
      shcode: "",
    };
    let _marchandiseHelpers = {
      cond: "",
      cvalue: "",
      ccurrency: "",
      fvalue: "",
      fcurrency: "",
      nbcont20: "",
      nbcont40: "",
      poids: "",
      volume: "",
      nbchassis: "",
      nbcolis: "",
      description: "",
      shcode: "",
    };
    // if (values.nom === '') {
    //   errors.nom = true;
    //   helpers.nom = 'Ce champ ne peut être vide';
    // }

    for (let val of [
      "cvalue",
      "fvalue",
      "poids",
      "volume",
      "nbchassis",
      "nbcolis",
    ]) {
      if (marchandise[val] == 0) {
        _marchandiseErrors[val] = true;
        _marchandiseHelpers[val] = "à renseigner";
      }
    }
    if (marchandise["nbcont20"] == 0 && marchandise["nbcont40"] == 0) {
      _marchandiseErrors["nbcont20"] = true;
      _marchandiseHelpers["nbcont20"] = "à renseigner";
      _marchandiseErrors["nbcont40"] = true;
      _marchandiseHelpers["nbcont40"] = "à renseigner";
    }

    detailsChassis.forEach((value, index) => {
      _cerrors.push({
        nchassis: "",
        marque: "",
        modele: "",
        cartegrise: "",
        contenu: "",
        annee: "",
      });
      _chelpers.push({
        nchassis: "",
        marque: "",
        modele: "",
        cartegrise: "",
        contenu: "",
        annee: "",
      });

      if (value.nchassis !== "") {
        let b = detailsChassis.find(
          (c, i) => c.nchassis === value.nchassis && index != i,
        );

        if (b) {
          _cerrors[index]["nchassis"] = true;
          _chelpers[index]["nchassis"] = formatMessage(
            intl,
            "create_besc_maritime_import_accordion_cargo_card_vehicle_helper_existing_number",
          );
        }
      }
    });

    detailsConteneur.forEach((value, index) => {
      _errors.push({
        ncont: "",
        taille: "",
        nplomb: "",
        type: "",
        chargement: "",
        poids: "",
        contenu: "",
      });
      _helpers.push({
        ncont: "",
        taille: "",
        nplomb: "",
        type: "",
        chargement: "",
        poids: "",
        contenu: "",
      });

      if (value.ncont !== "") {
        let regex = new RegExp(/[A-Z]{4}[0-9]{7}$/);

        let b = detailsConteneur.find(
          (c, i) => c.ncont === value.ncont && index != i,
        );

        if (b) {
          _errors[index]["ncont"] = true;
          _helpers[index]["ncont"] = formatMessage(
            intl,
            "create_besc_maritime_import_accordion_cargo_card_container_helper_existing_container",
          );
        }
        if (!regex.test(value.ncont.toUpperCase())) {
          _errors[index]["ncont"] = true;
          _helpers[index]["ncont"] = formatMessage(
            intl,
            "create_besc_maritime_import_accordion_cargo_card_container_helper_invalid_container",
          );
        }
      }

      if (value.nplomb !== "" && errors[index] && !errors[index]["nplomb"]) {
        let p = detailsConteneur.find(
          (c, i) => c.nplomb === value.nplomb && index != i,
        );
        if (p) {
          _errors[index]["nplomb"] = true;
          _helpers[index]["nplomb"] = formatMessage(
            intl,
            "create_besc_maritime_import_accordion_cargo_card_container_helper_existing_seal",
          );
        }
      }
    });

    // console.log("new _marchandiseErrors : ", _marchandiseErrors);
    // console.log("new _marchandiseHelpers : ", _marchandiseHelpers);

    // console.log("new _errors : ", _errors);
    // console.log("new _helpers : ", _helpers);

    // console.log("new _cerrors : ", _cerrors);
    // console.log("new _chelpers : ", _chelpers);

    setErrors(_errors);
    setHelpers(_helpers);
    setMarchandiseErrors(_marchandiseErrors);
    setMarchandiseHelpers(_marchandiseHelpers);
    setChassisErrors(_cerrors);
    setChassisHelpers(_chelpers);
  };

  const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);

  const debounceLoadSH = _.debounce(async (search) => {
    let key = isNumeric(search) ? "code" : "translations.description";

    try {
      const response = await fetch(
        props.api + "/api/hs_codes?" + key + "=" + search,
        {
          method: "GET",
          redirect: "follow",
          headers: {
            Accept: "application/ld+json",
            "Accept-Language": locale,
            Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
          },
        },
      );
      //await sleep(1e3); // For demo purposes.[]
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];

      let options = [];
      for (let s of _shippers) {
        options.push({
          code: s.code,
          desc: s.description,
        });
      }
      setCodesSH(options);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  const debounceLoadModeles = _.debounce(async (search) => {
    try {
      const response = await fetch(
        props.api + "/api/models?name=" + search,
        requestOptions,
      );

      //await sleep(1e3); // For demo purposes.
      let _shippers = await response.json();
      _shippers = _shippers["hydra:member"];

      let options = [];
      for (let s of _shippers) {
        options.push(s);
      }
      setModeles(options);
    } catch {
      (e) => {
        console.log("an error occured, details : ", e);
      };
    }
  }, 600);

  useEffect(() => {
    const _incoming = props.data.marchandise;
    const incoming = {
      ..._incoming,
      cvalue: normalizeNumberString(_incoming.cvalue) || "0",
      fvalue: normalizeNumberString(_incoming.fvalue) || "0",
    };

    if (incoming && Object.keys(incoming).length > 0) {
      console.log("marchandise(update coming from props):", incoming);

      setMarchandise((prev) => {
        // Remove null / undefined values from incoming
        const cleanedIncoming = Object.fromEntries(
          Object.entries(incoming).filter(
            ([_, value]) => value !== null && value !== undefined,
          ),
        );

        const merged = { ...prev, ...cleanedIncoming };

        console.log("prev:", prev);
        console.log("cleanedIncoming:", cleanedIncoming);
        console.log("merged:", merged);

        const same = Object.keys(merged).every(
          (key) => merged[key] === prev[key],
        );

        return same ? prev : merged;
      });
      setHydrated(true);

      // Only update counters if values exist

      if (!received2) {
        console.log("received2 : ", received2);
        setCCO20(Number(incoming.nbcont20 ?? 0));
        console.log("setting CCO20 to : ", Number(incoming.nbcont20));

        setCCO40(Number(incoming.nbcont40 ?? 0));
        console.log("setting CCO40 to : ", Number(incoming.nbcont40));
      }

      setCCH(Number(incoming.nbchassis ?? 0));

      setReceived1(true);
    }
  }, [props.data.marchandise]);

  useEffect(() => {
    if (props.data.detailsConteneur.length > 0) {
      console.log(
        "setting containers from parent as : ",
        props.data.detailsConteneur,
      );
      setDetailsConteneur(props.data.detailsConteneur);
      setReceived2(true);
    }
  }, [props.data.detailsConteneur]);

  useEffect(() => {
    console.log("props.data.detailsChassis : ", props.data.detailsChassis);
    if (props.data.detailsChassis.length > 0) {
      setDetailsChassis(props.data.detailsChassis);
      let _init = [...init];
      for (const [index, f] of props.data.detailsChassis.entries()) {
        _init.push({
          index: index,
          name: f.cartegrise,
        });
      }
      setInit(_init);
      setReceived3(true);
    } else {
      setInit([]);
    }
  }, [props.data.detailsChassis]);

  useEffect(() => {
    if (props.data.sh.length > 0) {
      setSH(props.data.sh);
      setReceived4(true);
    }
  }, [props.data.sh]);

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const uploadFile = async (index, event) => {
    const filenames = event.target.files;
    const fileName = filenames[0].name;
    if (filenames[0].size > 1048576) {
      // 1 MB in bytes
      notify(
        formatMessage(
          intl,
          "create_besc_maritime_import_accordion_cargo_card_vehicle_alert_file_size",
        ),
        "info",
        "center",
        "bottom",
        true,
        enqueueSnackbar,
      );
      event.target.value = ""; // clear the file input
    } else {
      let _values = [...detailsChassis];
      _values[index]["cartegrise"] = fileName;
      _values[index]["b64"] = await convertBase64(filenames[0]);
      setDetailsChassis(_values);
    }
  };

  const previousCCO20 = usePrevious(cCO20);
  const previousCCO40 = usePrevious(cCO40);
  const previousCCH = usePrevious(cCH);

  const isFormFilled = () => {
    let ncont20 = Number(marchandise.nbcont20);
    let ncont40 = Number(marchandise.nbcont40);
    let nch = Number(marchandise.nbchassis);

    let b =
      (Number.isInteger(nch) && nch > 0) ||
      (Number.isInteger(ncont20) && ncont20 > 0) ||
      (Number.isInteger(ncont40) && ncont40 > 0);

    b =
      b &&
      Boolean(marchandise.cvalue.toString().trim()) &&
      Boolean(marchandise.ccurrency.toString().trim()) &&
      Boolean(marchandise.fvalue.toString().trim()) &&
      Boolean(marchandise.fcurrency.toString().trim()) &&
      Boolean(marchandise.poids.toString().trim()) &&
      Boolean(marchandise.volume.toString().trim()) &&
      Boolean(marchandise.nbcolis.toString().trim());
    return b;
  };

  //ON APP LAUNCH
  useEffect(() => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        Accept: "application/ld+json",
        Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    let _currencies = [];
    let _classesT = [];

    //FETCH CLASSES TARIFAIRES

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: MASTER_API_URL + "/search/classe_tarifaires",
      headers: {
        "Content-Type": "application+json",
        "Accept-Language": locale,
        Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      },
      data: {
        mode: "maritime",
        sens: props.sens === "regule" ? "import" : props.sens,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("sucess!! response below :");
        console.log(response.data);
        let data = response.data;
        for (let res of data) {
          _classesT.push(res);
        }
        setClassesT(_classesT);
      })
      .catch((error) => {
        console.log("error!! error below :");
        console.log(error);
      });

    //FETCH CURRENCIES
    fetch(props.api + "/api/currencies?itemsPerPage=20", requestOptions)
      .then((response) => response.json())
      .then((result) => result["hydra:member"])
      .then((result) => {
        for (let res of result) {
          //let country = "";
          _currencies.push({ value: res.code, name: res.name });
        }
        setCurrencies(_currencies);
      })

      .catch((error) => console.log("error", error));

    //FETCH MODELES
  }, []);

  useEffect(() => {
    if (!filled) {
      setFilled(isFormFilled());
    }

    //required fields
    let form = document.getElementById("cargaison-form");
    let validity = form.checkValidity() && !!marchandise.cond;

    let isvalid = true;
    if (errors.length > 0) {
      for (const [index, err] of errors.entries()) {
        if (Object.values(err).includes(true)) {
          isvalid = false;

          break;
        }
      }
    }

    if (marchandiseErrors.length > 0) {
      for (const [index, err] of marchandiseErrors.entries()) {
        if (Object.values(err).includes(true)) {
          isvalid = false;

          break;
        }
      }
    }

    if (chassisErrors.length > 0) {
      for (const [index, err] of chassisErrors.entries()) {
        if (Object.values(err).includes(true)) {
          isvalid = false;

          break;
        }
      }
    }
    validity = validity && isvalid;

    console.log("cco20+cco40 : ", cCO20 + cCO40);

    let check1 =
      marchandise.cond === "conteneur"
        ? cCO20 + cCO40 > 0 && detailsConteneur.length > 0
        : true;
    let check2 =
      marchandise.cond === "ro-ro"
        ? cCH > 0 && detailsChassis.length > 0
        : true;

    console.log("details conteneur : ", detailsConteneur);
    console.log("check1(conteneurs) : ", check1);
    console.log("details chassis : ", detailsChassis);
    console.log("check2(chassis) : ", check2);

    validity = validity && check1 && check2;

    setValid((prev) => (prev === validity ? prev : validity));
    props.setValidity(validity);
    if (
      validity ||
      (props.sens.toLowerCase() === "export" &&
        props.mode !== "edit" &&
        received1) ||
      received2 ||
      received3 ||
      received4
    ) {
      console.log("FORM IS VALID, SENING...");
      console.log(marchandise);
      console.log(detailsConteneur);
      console.log(detailsChassis);
      let normalizedMarchandise = {
        ...marchandise,
        cvalue: normalizeNumberString(marchandise.cvalue),
        fvalue: normalizeNumberString(marchandise.fvalue),
      };

      let normalizedParentMarchandise = {
        ...props.data.marchandise,
        cvalue: normalizeNumberString(props.data.marchandise?.cvalue),
        fvalue: normalizeNumberString(props.data.marchandise?.fvalue),
      };

      const sameMarchandise =
        JSON.stringify(normalizedMarchandise) ===
        JSON.stringify(normalizedParentMarchandise);

      if ((validity || hydrated || props.mode !== "edit") && !sameMarchandise) {
        props.sendMarchandise(normalizedMarchandise);
      }
      if (validity && props.sens.toLowerCase() !== "export") {
        console.log("detailsCont to send : ", detailsConteneur);
        props.sendDetailsConteneur(detailsConteneur);
        props.sendDetailsChassis(detailsChassis);
        props.sendSH(SH);
      }
      console.log("props : ", props);
      if (props.sens.toLowerCase() === "export") {
        console.log("sending for export");
        props.sendDetailsConteneur(detailsConteneur);
        props.sendDetailsChassis(detailsChassis);
        props.sendSH(SH);
      }
    }
  }, [
    marchandise,
    detailsConteneur,
    detailsChassis,
    // isFormFilled,
    SH,
    cCO20,
    cCO40,
    cCH,
  ]);

  useEffect(() => {
    if (
      props.sens.toLowerCase() === "export" &&
      props.mode === "edit" &&
      (received2 || props.received22)
    ) {
      console.log("RECEIVED, SENING...");
      console.log(detailsConteneur);
      props.sendDetailsConteneur(detailsConteneur);
    }
  }, [detailsConteneur]);

  useEffect(() => {
    console.log("received2 : ", received2, " received22 : ", props.received22);
    const skipContainerRebuild = skipContainerRebuildRef.current;
    skipContainerRebuildRef.current = false;
    if (props.mode !== "edit" || received2 || props.received22) {
      if (!skipContainerRebuild) {
      console.log("ccO20 : ", cCO20, " previous ccO20 : ", previousCCO20);
      let _details = [...detailsConteneur];
      console.log("DETAILS : ", _details);
      let _20ft = _details.filter((v) => v.taille === "20");
      let _40ft = _details.filter((v) => v.taille === "40");
      let nbOfTwenty = _20ft.length;
      let nbOfFourty = _40ft.length;
      console.log("20 foot : ", _20ft);
      console.log("40 foot : ", _40ft);
      if (!isNaN(previousCCO20) && previousCCO20 !== cCO20) {
        console.log("20 FT CONTAINER HANDLING");
        let diff = cCO20 - previousCCO20;
        if (previousCCO20 < cCO20) {
          console.log("we are adding ", diff, " 20 ft containers");
          for (let i = 0; i < diff; i++) {
            _20ft.push({
              ncont: "",
              taille: "20",
              nplomb: "",
              type: "",
              chargement: "",
              poids: "0",
              contenu: "",
            });
          }
        } else {
          console.log("we are removing ", -diff, " 20ft containers");
          //LETS FIRST CLEAR ALL
          _20ft = [];
          console.log("nbOfTwenty : ", nbOfTwenty);
          //NOW LETS PUSH THE DIFFERENCE
          for (let i = 0; i < nbOfTwenty + diff; i++) {
            _20ft.push({
              ncont: "",
              taille: "20",
              nplomb: "",
              type: "",
              chargement: "",
              poids: "0",
              contenu: "",
            });
          }
        }
      }

      if (!isNaN(previousCCO40) && previousCCO40 !== cCO40) {
        console.log("40 FT CONTAINER HANDLING");
        let diff = cCO40 - previousCCO40;
        if (previousCCO40 < cCO40) {
          console.log("we are adding ", diff, " 40ft containers");
          for (let i = 0; i < diff; i++) {
            _40ft.push({
              ncont: "",
              taille: "40",
              nplomb: "",
              type: "",
              chargement: "",
              poids: "0",
              contenu: "",
            });
          }
        } else {
          //   console.log("we are removing ", -diff, " 40ft containers");
          //LETS FIRST CLEAR ALL
          console.log("nbOfFOurty : ", nbOfFourty);
          _40ft = [];

          //NOW LETS PUSH THE DIFFERENCE
          for (let i = 0; i < nbOfFourty + diff; i++) {
            _40ft.push({
              ncont: "",
              taille: "40",
              nplomb: "",
              type: "",
              chargement: "",
              poids: "",
              contenu: "",
            });
          }
        }
      }
      //  else {
      //   console.log(
      //     "NUMBER OF 40FT CONTAINERS UNCHANGED prev : ",
      //     previousCCO40,
      //     " 40 : ",
      //     cCO40,
      //     "EQUALITY TEST : ",
      //     previousCCO40 == cCO40,
      //     " 2ND TEST : ",
      //     previousCCO40 === cCO40,
      //     "3RD TEST : ",
      //     previousCCO40 !== cCO40,
      //     " 4TH TEST : ",
      //     !isNaN(previousCCO40) && previousCCO40 !== cCO40
      //   );
      // }
      // setDetailsConteneur(_20ft.concat(_40ft));

      console.log("20 + 40 : ", _20ft.concat(_40ft));
      if (_20ft.concat(_40ft).length > 0) {
        setDetailsConteneur(_20ft.concat(_40ft));
      }

      if (cCO20 == 0 && cCO40 == 0) {
        console.log("both are 0 wiping all containers");
        setDetailsConteneur([]);
      }
      }

      if (!isNaN(previousCCH) && previousCCH !== cCH) {
        console.log("VEHICLE HANDLING");
        let diff = cCH - previousCCH;
        let _details = [...detailsChassis];
        console.log("old details chassis : ", _details);
        if (previousCCH < cCH) {
          console.log("we are adding ", diff, " chassis");
          for (let i = 0; i < diff; i++) {
            _details.push({
              nchassis: "",
              marque: "",
              modele: "",
              cartegrise: "",
              contenu: "",
              annee: "",
            });
          }
        } else {
          console.log("we are removing ", -diff, " chassis");

          //LETS FIRST CLEAR ALL
          _details = [];

          //NOW LETS PUSH THE DIFFERENCE
          for (let i = 0; i < detailsChassis.length + diff; i++) {
            _details.push({
              nchassis: "",
              marque: "",
              modele: "",
              cartegrise: "",
              contenu: "",
              annee: "",
            });
          }
        }
        setDetailsChassis(_details);
      }

      if (cCH == 0) {
        console.log("ch is 0 wiping all chassis");
        setDetailsChassis([]);
        setInit([]);
      }
    }
  }, [cCO20, cCO40, cCH]);

  useEffect(() => {
    console.log("marchandise : ", marchandise);
    console.log("first : ", false);

    console.log(
      "detailsConteneur changed , detailsConteneur : ",
      detailsConteneur,
    );
    if (detailsConteneur.length > 0) {
      setCCO20(Number(marchandise.nbcont20));
      setCCO40(Number(marchandise.nbcont40));
    }

    if (detailsChassis.length > 0) {
      setCCH(Number(marchandise.nbchassis));
    }

    validateValues();
  }, [marchandise, detailsConteneur, detailsChassis]);

  useEffect(() => {
    console.log("TYPE MARCHANDISE CHANGED...");
    console.log("marchandise : ", marchandise);
    if (classesT.length > 0) {
      console.log("classesT loaded, classesT : ", classesT);
      let _mtypes = classesT.filter(
        (value) => value.conditionnement == marchandise.cond,
      );
      console.log("mtypes to set : ", _mtypes);
      setMtypes(_mtypes);
    }
  }, [marchandise.typeMarchandise, classesT]);

  useEffect(() => {
    props.setConditionnement(marchandise.cond);
  }, [marchandise.cond]);

  useEffect(() => {
    console.log("mtypes changed... mtypes : ", mtypes);
  }, [mtypes]);

  const handleAutoCompleteChangeM = (index, event, newValue) => {
    event.persist(event);

    if (newValue && typeof newValue["name"] === "string") {
      console.log("NEWVALUE BRAND : ", newValue);
      let _detailsChassis = [...detailsChassis];
      detailsChassis[index].modele = newValue.name + ", " + newValue.brand.name;
      detailsChassis[index].marque = newValue.brand.name;
      setDetailsChassis(_detailsChassis);
    } else if (newValue && newValue.inputValue) {
      let _detailsChassis = [...detailsChassis];
      (_detailsChassis[index].modele = newValue.inputValue),
        setDetailsChassis(_detailsChassis);
    } else {
      let _detailsChassis = [...detailsChassis];
      (_detailsChassis[index].modele = ""), setDetailsChassis(_detailsChassis);
    }
  };

  const normalizeContainerSize = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const numeric = Number(String(value).trim().replace(",", "."));
    if (numeric === 20) return "20";
    if (numeric === 40) return "40";
    return "";
  };

  const matchContainerOption = (value, options) => {
    const text = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");
    if (!text) return "";
    const found = options.find(
      (option) => option.toLowerCase().replace(/\s+/g, "") === text,
    );
    return found || "";
  };

  const containersFromSheetRows = (rows) => {
    const imported = [];
    rows.forEach((row) => {
      if (!Array.isArray(row)) return;
      const size = normalizeContainerSize(row[1]);
      if (!size) return;
      const weight = row[5];
      imported.push({
        ncont: String(row[0] || "")
          .trim()
          .toUpperCase(),
        taille: size,
        nplomb: String(row[2] || "").trim(),
        type: matchContainerOption(row[3], typesC),
        chargement: matchContainerOption(row[4], typesCh),
        poids:
          weight === null || weight === undefined || weight === ""
            ? "0"
            : String(weight).replace(",", "."),
        contenu: String(row[6] || "").trim(),
      });
    });
    return imported;
  };

  const handleContainerImport = async (event) => {
    const selected = event.target.files && event.target.files[0];
    event.target.value = "";
    if (!selected) return;

    const extension = selected.name.split(".").pop().toLowerCase();
    if (!["xlsx", "xls"].includes(extension)) {
      notify(
        formatMessage(
          intl,
          "create_besc_maritime_import_accordion_cargo_card_container_import_invalid",
        ),
        "warning",
        "center",
        "bottom",
        true,
        enqueueSnackbar,
      );
      return;
    }

    try {
      const buffer = await selected.arrayBuffer();
      const workbook = read(buffer, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = utils.sheet_to_json(sheet, {
        header: 1,
        defval: "",
        raw: true,
      });
      const imported = containersFromSheetRows(rows);
      if (imported.length === 0) {
        notify(
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_cargo_card_container_import_empty",
          ),
          "warning",
          "center",
          "bottom",
          true,
          enqueueSnackbar,
        );
        return;
      }

      const twenty = imported.filter((item) => item.taille === "20");
      const forty = imported.filter((item) => item.taille === "40");
      const next20 = twenty.length;
      const next40 = forty.length;
      if (Number(cCO20) !== next20 || Number(cCO40) !== next40) {
        skipContainerRebuildRef.current = true;
      }
      setMarchandise((prev) => ({
        ...prev,
        nbcont20: String(next20),
        nbcont40: String(next40),
      }));
      setDetailsConteneur(imported);
      setCCO20(next20);
      setCCO40(next40);
      notify(
        formatMessage(
          intl,
          "create_besc_maritime_import_accordion_cargo_card_container_import_success",
          { twenty: next20, forty: next40 },
        ),
        "success",
        "center",
        "bottom",
        true,
        enqueueSnackbar,
      );
    } catch (error) {
      notify(
        formatMessage(
          intl,
          "create_besc_maritime_import_accordion_cargo_card_container_import_error",
        ),
        "error",
        "center",
        "bottom",
        true,
        enqueueSnackbar,
      );
    }
  };

  const handleChange = (event) => {
    // setReceived1(true);
    event.persist(event);

    if (event.target.name === "produits") {
      let val = [...SH];
    }
    if (event.target.name == "cond") {
      let _mtypes = classesT.filter(
        (value) => value.conditionnement == event.target.value,
      );
      console.log("name : ", event.target.name);
      console.log("value : ", event.target.value);

      switch (event.target.value) {
        case "conteneur":
          console.log("case conteneur");
          setMarchandise({
            ...marchandise,
            [event.target.name]: event.target.value,
          });
          break;
        case "ro-ro":
          console.log("case roro");
          setMarchandise({
            ...marchandise,
            [event.target.name]: event.target.value,
            ["nbcont20"]: 0,
            ["nbcont40"]: 0,
          });
          break;
        case "conventionnel":
          console.log("case conventionnel");
          setMarchandise({
            ...marchandise,
            [event.target.name]: event.target.value,
            ["nbcont20"]: 0,
            ["nbcont40"]: 0,
            ["nbchassis"]: 0,
            ["nbmotos"]: 0,
          });
          break;
        case "vrac":
          console.log("case vrac");
          setMarchandise({
            ...marchandise,
            [event.target.name]: event.target.value,
            ["nbcont20"]: 0,
            ["nbcont40"]: 0,
            ["nbchassis"]: 0,
            ["nbmotos"]: 0,
            ["nbcolis"]: 1,
          });
          break;
        default:
      }

      setMtypes(_mtypes);
    } else {
      setMarchandise({
        ...marchandise,
        [event.target.name]: event.target.value,
      });
    }
    if (!isNaN(event.target.value) && event.target.name === "nbcont20") {
      setCCO20(Number(event.target.value));
    }
    if (!isNaN(event.target.value) && event.target.name === "nbcont40") {
      setCCO40(Number(event.target.value));
    }
    if (!isNaN(event.target.value) && event.target.name === "nbchassis") {
      setCCH(Number(event.target.value));
    }
  };

  const removeSHCode = (_index) => {
    let _SH = [...SH];
    _SH = _SH.filter((SH, index) => index !== _index);
    setSH(_SH);
  };

  const handleAutoCompleteSH = (event, newValue) => {
    if (newValue && typeof newValue["code"] === "string") {
      let _values = [...SH];
      let newObj = {
        code: newValue.code,
        desc: newValue.desc,
      };
      let exists =
        _values.findIndex((element) => element.code === newValue.code) > -1;
      if (!exists) {
        _values.unshift({
          code: newValue.code,
          desc: newValue.desc,
          products: "",
          weight: 0,
          value: 0,
          curr: "USD",
        });
      }
      setSH(_values);
      setMarchandise({ ...marchandise, shcode: "" });
      setOpenSH(false);
      document.activeElement.blur();
    } else if (newValue && newValue.inputValue) {
      //TODO
    } else {
      //TODO
    }
  };

  const handleAutoCompleteModele = (index, event, newValue) => {
    event.persist(event);
    let _details = [...detailsChassis];
    _details[index].modele = newValue;

    setDetailsChassis(_details);
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    typography: {
      fontSize: 13,
    },
    borderLeft: {
      borderLeft: "1px solid",
      marginBottom: theme.spacing(1),
    },
    borderBoth: {
      borderLeft: "1px solid",
      borderRight: "1px solid",
      marginBottom: theme.spacing(1),
    },
    tabPanelRoot: {
      padding: 0,
    },
    panel: {
      width: "100%",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: 300,
    },
  }));

  const classes = useStyles();
  return (
    <>
      <form id="cargaison-form">
        <Card className="p-4 mb-4">
          {/* -------------------------------------- Marchandise ----------------------------------- */}
          <div className="font-size-lg font-weight-bold">
            {formatMessage(
              intl,
              "create_besc_maritime_import_accordion_cargo_card_cargo",
            )}
          </div>

          <div>
            <Grid
              container
              direction="row"
              alignItems="center"
              alignContent="center"
              alignSelf="center"
              spacing={1}
              xs={12}
            >
              <Grid item xs={12} sm={8} md={4}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                  required
                >
                  <TextField
                    className="m-2"
                    id="outlined-select-currency"
                    select
                    size="small"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning",
                    )}
                    value={marchandise.cond}
                    InputProps={{
                      readOnly:
                        (role.user &&
                          role.user.roles[0].name === "Modificateur") ||
                        (role &&
                          role.user &&
                          role.user.company.consignataire &&
                          props.sens === "import"),
                    }}
                    name="cond"
                    required
                    variant="outlined"
                    onChange={(event) => handleChange(event)}
                  >
                    {conditionnements.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label.toUpperCase()}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
              {marchandise.cond === "conteneur" && (
                <Grid item xs={12} md={8}>
                  <div className="m-2 d-flex flex-wrap align-items-center">
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      className="m-1"
                      href={`${process.env.PUBLIC_URL}/ContainerImportationFormat.xlsx`}
                      download="ContainerImportationFormat.xlsx"
                    >
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_cargo_card_container_download_template",
                      )}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className="m-1"
                      component="label"
                    >
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_cargo_card_container_import_file",
                      )}
                      <input
                        type="file"
                        hidden
                        accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                        onChange={handleContainerImport}
                      />
                    </Button>
                    <Typography variant="body2" className="m-1">
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_cargo_card_container_import_help",
                      )}
                    </Typography>
                  </div>
                </Grid>
              )}
              <Grid item xs={6} sm={4} md={2}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    id="standard-basic"
                    required={props.sens !== "transit"}
                    size="small"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_commercial_value",
                    )}
                    type="number"
                    inputProps={{ min: 0, step: "any" }}
                    variant="outlined"
                    value={marchandise.cvalue}
                    name="cvalue"
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    id="outlined-select-currency"
                    select
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_commercial_currency",
                    )}
                    size="small"
                    required={props.sens !== "transit"}
                    value={marchandise.ccurrency}
                    name="ccurrency"
                    onChange={(event) => handleChange(event)}
                    variant="outlined"
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    id="outlined-basic"
                    size="small"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_fob_value",
                    )}
                    required={props.sens !== "transit"}
                    type="number"
                    inputProps={{ min: 0, step: "any" }}
                    variant="outlined"
                    value={marchandise.fvalue}
                    name="fvalue"
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    id="outlined-select-currency"
                    size="small"
                    select
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_fob_currency",
                    )}
                    required={props.sens !== "transit"}
                    value={marchandise.fcurrency}
                    name="fcurrency"
                    variant="outlined"
                    onChange={(event) => handleChange(event)}
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={8} md={4}>
                <FormControl
                  fullWidth
                  className={classes.margin}
                  variant="outlined"
                >
                  <TextField
                    className="m-2"
                    id="outlined-select-currency"
                    select
                    disabled={
                      ["ro-ro"].includes(marchandise.cond) ||
                      (props.sens === "import" &&
                        ["conteneur"].includes(marchandise.cond)) ||
                      props.sens === "transit"
                    }
                    size="small"
                    label={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_product_type",
                    )}
                    value={marchandise.typeMarchandise}
                    InputProps={{
                      readOnly:
                        role.user && role.user.roles[0].name === "Modificateur",
                    }}
                    name="typeMarchandise"
                    required={
                      props.sens !== "transit" &&
                      ["vrac", "conventionnel"].includes(marchandise.cond)
                    }
                    variant="outlined"
                    onChange={(event) => handleChange(event)}
                  >
                    {mtypes.map((option) => (
                      <MenuItem key={option.value} value={option.uuid}>
                        {option.libelle.toUpperCase()}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={4} md={2}>
                <FormControl
                  fullWidth
                  size="small"
                  className={classes.margin}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-amount">
                    {formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_weight",
                    )}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    value={marchandise.poids}
                    name="poids"
                    type="number"
                    readOnly={
                      role.user &&
                      role.user.roles[0].name === "Modificateur" &&
                      ["vrac", "conventionnel"].includes(marchandise.cond)
                    }
                    inputProps={{
                      min: 0,
                      step: "any",
                      required: true,
                    }}
                    required
                    // endAdornment={
                    //   <InputAdornment position="end">en kg</InputAdornment>
                    // }
                    labelWidth={180}
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <FormControl
                  fullWidth
                  size="small"
                  className={classes.margin}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-amount">
                    <small>
                      {formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_cargo_card_cargo_label_volume",
                      )}{" "}
                      m&sup3;
                    </small>
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    value={marchandise.volume}
                    required
                    type="number"
                    inputProps={{
                      min: 0,
                      step: "any",
                      required: true,
                    }}
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                    name="volume"
                    // endAdornment={
                    //   <InputAdornment position="end">en m&sup3;</InputAdornment>
                    // }
                    labelWidth={180}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={2} md={1}>
                <FormControl
                  fullWidth
                  size="small"
                  className={classes.margin}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-amount">
                    {formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_twenty",
                    )}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    value={marchandise.nbcont20}
                    disabled={marchandise.cond !== "conteneur"}
                    required
                    type="number"
                    inputProps={{ min: 0 }}
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                    name="nbcont20"
                    labelWidth={180}
                    readOnly={
                      role.user && role.user.roles[0].name === "Modificateur"
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={2} md={1}>
                <FormControl
                  fullWidth
                  size="small"
                  className={classes.margin}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-amount">
                    {formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_forty",
                    )}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    value={marchandise.nbcont40}
                    disabled={marchandise.cond !== "conteneur"}
                    required
                    type="number"
                    inputProps={{ min: 0 }}
                    readOnly={
                      role.user && role.user.roles[0].name === "Modificateur"
                    }
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                    name="nbcont40"
                    labelWidth={180}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={2} md={1}>
                <FormControl
                  fullWidth
                  size="small"
                  className={classes.margin}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-amount">
                    {formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_vehicles",
                    )}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    value={marchandise.nbchassis}
                    required
                    type="number"
                    inputProps={{ min: 0 }}
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    disabled={
                      !["conteneur", "ro-ro"].includes(marchandise.cond)
                    }
                    onChange={(event) => handleChange(event)}
                    readOnly={
                      role.user && role.user.roles[0].name === "Modificateur"
                    }
                    name="nbchassis"
                    labelWidth={180}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={2} md={1}>
                <FormControl
                  fullWidth
                  size="small"
                  className={classes.margin}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-amount">
                    {formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_motos",
                    )}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    value={marchandise.nbmotos}
                    required
                    type="number"
                    inputProps={{ min: 0 }}
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    disabled={
                      !["conteneur", "ro-ro"].includes(marchandise.cond)
                    }
                    onChange={(event) => handleChange(event)}
                    readOnly={
                      role.user && role.user.roles[0].name === "Modificateur"
                    }
                    name="nbmotos"
                    labelWidth={180}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={11}>
                <FormControl
                  fullWidth
                  size="small"
                  className={classes.margin}
                  variant="outlined"
                >
                  <Autocomplete
                    size="small"
                    open={openSH}
                    onOpen={() => {
                      setOpenSH(true);
                    }}
                    onClose={() => {
                      setOpenSH(false);
                    }}
                    value={marchandise.shcode}
                    onChange={(event, newValue) =>
                      handleAutoCompleteSH(event, newValue)
                    }
                    loadingText={formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_searching",
                    )}
                    filterOptions={(options, params) => {
                      if (!loadingSH) {
                        const filtered = filter(options, params);

                        // Suggest the creation of a new value
                        // if (
                        //   params.inputValue !== "" &&
                        //   filtered.length === 0 &&
                        //   !loadingSH
                        // ) {
                        //   filtered.push({
                        //     inputValue: params.inputValue,
                        //     text: "Créer " + params.inputValue,
                        //   });
                        // }

                        return filtered;
                      } else {
                        return [];
                      }
                    }}
                    clearOnBlur
                    id="free-solo-with-text-demo"
                    options={codesSH}
                    loading={loadingSH}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.text;
                      }
                      // Regular option

                      return option.code + " - " + option.desc;
                    }}
                    // renderOption={(option) => option.niu}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        label={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_cargo_card_cargo_label_sh_code",
                        )}
                        variant="outlined"
                        onChange={(event) => {
                          event.persist(event);
                          if (event.target.value.length > 2) {
                            if (!fetching) {
                              setFetching(true);
                            }
                            debounceLoadSH(event.target.value);
                          }
                          // if (event.target.value.length > 2) {
                          //   setFetching(true);

                          // }
                        }}
                      />
                    )}
                  ></Autocomplete>
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={2} md={1}>
                <FormControl
                  fullWidth
                  size="small"
                  className={classes.margin}
                  variant="outlined"
                >
                  <InputLabel htmlFor="outlined-adornment-amount">
                    {formatMessage(
                      intl,
                      "create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_packages",
                    )}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    required
                    type="number"
                    inputProps={{ min: 0 }}
                    value={
                      marchandise.cond === "vrac" ? 1 : marchandise.nbcolis
                    }
                    readOnly={marchandise.cond === "vrac"}
                    disabled={marchandise.cond === "ro-ro"}
                    onKeyDown={(evt) => {
                      if (
                        isNaN(evt.key) &&
                        evt.key !== "." &&
                        evt.key !== "Backspace" &&
                        evt.key !== "ArrowLeft" &&
                        evt.key !== "ArrowRight" &&
                        evt.key !== "," &&
                        evt.key !== "v" &&
                        evt.key !== "V"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={(event) => handleChange(event)}
                    name="nbcolis"
                    labelWidth={180}
                  />
                </FormControl>
              </Grid>

              {/* <Grid item xs={3} sm={2} md={1}>
                <Typography variant="h6"></Typography>
              </Grid> */}

              {/*<>
                <Grid item xs={6} sm={4} md={3}>
                  <Typography variant="h6">Code</Typography>
                </Grid>
                <Grid item xs={12} sm={9} md={9}>
                  <Typography variant="h6">Description</Typography>
                </Grid>
              </>*/}
              <Card className="w-full w-96 p-12 mb-12">
                {SH.map((code, index) => {
                  return (
                    <>
                      <Grid container direction="row" spacing={2} xs={12}>
                        <Grid item xs={3} sm={2} md={1}>
                          <div className="font-size-sm font-weight-bold">
                            {index + 1 + "."}
                          </div>
                        </Grid>
                        <Grid item xs={3} sm={2} md={1}>
                          <Typography variant="h6">{code.code}</Typography>
                        </Grid>

                        {/* <Divider orientation="vertical" flexItem /> */}
                        <Grid item xs={12} sm={12} md={10} fullWidth>
                          {/* <Divider orientation="vertical" flexItem /> */}
                          <Typography
                            fullWidth
                            variant="text"
                            className={classes.typography}
                          >
                            {code.desc}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={10} md={5}>
                          <TextField
                            fullWidth
                            className="m-2"
                            size="small"
                            required
                            multiline
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_cargo_label_product",
                            )}
                            variant="outlined"
                            name="products"
                            value={code.products}
                            onChange={(event) => handleChangeSH(index, event)}
                          ></TextField>
                        </Grid>
                        <Grid item xs={6} sm={3} md={2}>
                          <TextField
                            fullWidth
                            className="m-2"
                            size="small"
                            required
                            type="number"
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_cargo_label_product_weight",
                            )}
                            variant="outlined"
                            name="weight"
                            inputProps={{
                              min: 0,
                              step: "any",
                            }}
                            value={code.weight}
                            onChange={(event) => handleChangeSH(index, event)}
                          ></TextField>
                        </Grid>
                        <Grid item xs={6} sm={3} md={2}>
                          <TextField
                            fullWidth
                            className="m-2"
                            size="small"
                            required
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_cargo_label_product_value",
                            )}
                            variant="outlined"
                            type="number"
                            onKeyDown={(evt) => {
                              if (
                                isNaN(evt.key) &&
                                evt.key !== "." &&
                                evt.key !== "Backspace" &&
                                evt.key !== "ArrowLeft" &&
                                evt.key !== "ArrowRight" &&
                                evt.key !== "," &&
                                evt.key !== "v" &&
                                evt.key !== "V"
                              ) {
                                evt.preventDefault();
                              }
                            }}
                            inputProps={{
                              min: 0,
                              step: "any",
                            }}
                            name="value"
                            value={code.value}
                            onChange={(event) => handleChangeSH(index, event)}
                          ></TextField>
                        </Grid>
                        <Grid item xs={6} sm={3} md={2}>
                          <TextField
                            fullWidth
                            className="m-2"
                            size="small"
                            required
                            select
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_cargo_label_product_currency",
                            )}
                            variant="outlined"
                            name="curr"
                            defaultValue="USD"
                            value={code.curr}
                            onChange={(event) => handleChangeSH(index, event)}
                          >
                            {currencies.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.value}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={2} sm={1} md={1}>
                          <IconButton
                            aria-label="delete"
                            onClick={() => removeSHCode(index)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                      <Divider className="my-4" />
                    </>
                  );
                })}
              </Card>
            </Grid>
          </div>
        </Card>
        {/* -------------------------------------- Détail de la cargaison ----------------------------------- */}

        {/* {filled && */}
        {(marchandise.nbcont20 > 0 || marchandise.nbcont40 > 0) &&
          marchandise.cond === "conteneur" && (
            <Card className="p-4 mb-4">
              {/* -------------------------------------- Conteneurs ----------------------------------- */}

              <div className="font-size-lg font-weight-bold">
                {formatMessage(
                  intl,
                  "create_besc_maritime_import_accordion_cargo_card_container",
                )}
              </div>
              {detailsConteneur.map((value, index) => {
                return (
                  <div>
                    <div className="font-size-sm font-weight-bold">
                      <Divider className="my-4" />
                      {index + 1 + "."}
                    </div>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      alignContent="center"
                      alignSelf="center"
                      spacing={1}
                      xs={12}
                    >
                      <Grid item xs={6} sm={4} md={2}>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            size="small"
                            required
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_container_label_number",
                            )}
                            variant="outlined"
                            name="ncont"
                            value={value.ncont}
                            onChange={(event) =>
                              handleChangeConteneur(index, event)
                            }
                            error={!errors[index] ? false : errors[index].ncont}
                          ></TextField>
                          <FormHelperText error>
                            {!helpers[index] ? null : helpers[index].ncont}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={4} md={2} sx={{ minWidth: "70px" }}>
                        <FormControl
                          fullWidth
                          size="small"
                          className={classes.margin}
                          variant="outlined"
                        >
                          <InputLabel htmlFor="outlined-adornment-amount">
                            {formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_container_label_size",
                            )}
                          </InputLabel>
                          <OutlinedInput
                            className="m-2"
                            id="outlined-select-currency"
                            name="taille"
                            value={value.taille}
                            type="number"
                            inputProps={{ min: 0 }}
                            labelWidth={20}
                            readOnly={true}
                            onChange={(event) =>
                              handleChangeConteneur(index, event)
                            }
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            size="small"
                            required
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_container_label_seal",
                            )}
                            variant="outlined"
                            name="nplomb"
                            value={value.nplomb}
                            onChange={(event) =>
                              handleChangeConteneur(index, event)
                            }
                            error={
                              !errors[index] ? false : errors[index].nplomb
                            }
                          ></TextField>
                          <FormHelperText error>
                            {!helpers[index] ? null : helpers[index].nplomb}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        xs={props.sens === "export" ? 6 : 6}
                        sm={props.sens === "export" ? 4 : 4}
                        md={props.sens === "export" ? 2 : 2}
                      >
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            size="small"
                            required
                            id="outlined-select-currency"
                            select
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_container_label_type",
                            )}
                            name="type"
                            value={value.type}
                            variant="outlined"
                            onChange={(event) =>
                              handleChangeConteneur(index, event)
                            }
                          >
                            {typesC.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </TextField>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={4} md={2}>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            size="small"
                            required
                            id="outlined-select-currency"
                            select
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_container_label_loading",
                            )}
                            name="chargement"
                            value={value.chargement}
                            variant="outlined"
                            onChange={(event) =>
                              handleChangeConteneur(index, event)
                            }
                          >
                            {typesCh.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </TextField>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6} sm={4} md={2}>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            size="small"
                            id="outlined-select-currency"
                            label={
                              props.sens === "export"
                                ? "Vgm"
                                : formatMessage(
                                    intl,
                                    "create_besc_maritime_import_accordion_cargo_card_container_label_weight",
                                  )
                            }
                            type="number"
                            inputProps={{
                              min: 0,
                              step: "any",
                              required: true,
                            }}
                            required
                            variant="outlined"
                            onKeyDown={(evt) => {
                              if (
                                isNaN(evt.key) &&
                                evt.key !== "." &&
                                evt.key !== "Backspace" &&
                                evt.key !== "ArrowLeft" &&
                                evt.key !== "ArrowRight" &&
                                evt.key !== "," &&
                                evt.key !== "v" &&
                                evt.key !== "V"
                              ) {
                                evt.preventDefault();
                              }
                            }}
                            name="poids"
                            value={value.poids}
                            onChange={(event) =>
                              handleChangeConteneur(index, event)
                            }
                          ></TextField>
                        </FormControl>
                      </Grid>

                      {/* {props.sens === "export" && (
                        <>
                           <Grid item xs={6} sm={4} md={2}>
                            <FormControl
                              fullWidth
                              className={classes.margin}
                              variant="outlined"
                            >
                              <TextField
                                className="m-2"
                                size="small"
                                id="outlined-select-currency"
                                label="Vgm"
                                type="number"
                                inputProps={{ min: 0 }}
                                name="vgm"
                                value={value.vgm}
                                variant="outlined"
                                onKeyDown={(evt) => {
                                  if (
                                    isNaN(evt.key) &&
                                    evt.key !== "." &&
                                    evt.key !== "Backspace" &&
                                    evt.key !== "ArrowLeft" &&
                                    evt.key !== "ArrowRight" &&
                                    evt.key !== "," &&
                                    evt.key !== "v" &&
                                    evt.key !== "V"
                                  ) {
                                    evt.preventDefault();
                                  }
                                }}
                                onChange={(event) =>
                                  handleChangeConteneur(index, event)
                                }
                              ></TextField>
                            </FormControl>
                          </Grid> 

                           <Grid item xs={3} sm={2} md={1}>
                            <FormControl
                              fullWidth
                              className={classes.margin}
                              variant="outlined"
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                hidden={value.types === ""}
                                // onClick={
                                //   "document.querySelector('file-upload'" + index + ').click()'
                                // }
                                className="m-2"
                              >
                                <label
                                  htmlFor={"file-upload" + index}
                                  className={classes.panel}
                                >
                                  <FontAwesomeIcon
                                    icon={["fas", "file-upload"]}
                                  />
                                </label>
                              </Button>
                              <Input
                                id={"file-upload" + index}
                                type="file"
                                name="greycard"
                                hidden
                                // accept="application/pdf"
                                onChange={event => uploadFile(index, event)}
                              />
                            </FormControl>
                          </Grid> 
                          { <Grid
                            item
                            xs={12}
                            sm={8}
                            md={4}
                            alignContent="center"
                            alignItems="center"
                          >
                        
                            <FormControl
                              fullWidth
                              className={classes.margin}
                              variant="outlined"
                            >
                              <TextField
                                className="m-2"
                                size="small"
                                id="outlined-select-currency"
                                label="VGM"
                                name="fichiervgm"
                                value={value.fichiervgm}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                InputProps={{
                                  readOnly: true
                                }}
                                variant="outlined"
                                onChange={event =>
                                  handleChangeConteneur(index, event)
                                }
                              ></TextField>
                            </FormControl>
                          </Grid> }
                        </>
                      )} */}

                      <Grid item xs={12}>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            size="small"
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_container_label_content",
                            )}
                            multiline
                            name="contenu"
                            value={value.contenu}
                            variant="outlined"
                            onChange={(event) =>
                              handleChangeConteneur(index, event)
                            }
                          ></TextField>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
            </Card>
          )}
        {/* {filled && */}
        {marchandise.nbchassis > 0 &&
          (marchandise.cond === "conteneur" ||
            marchandise.cond === "ro-ro") && (
            <Card className="p-4 mb-4">
              {/* -------------------------------------- Chassis ----------------------------------- */}

              <div className="font-size-lg font-weight-bold">
                {formatMessage(
                  intl,
                  "create_besc_maritime_import_accordion_cargo_card_vehicle",
                )}
              </div>
              {detailsChassis.map((value, index) => {
                return (
                  <div>
                    <div className="font-size-sm font-weight-bold">
                      <Divider className="my-4" />
                      {index + 1 + "."}
                    </div>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      alignContent="center"
                      alignSelf="center"
                      spacing={1}
                      xs={12}
                    >
                      <Grid item xs={6} sm={4} md={2}>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            required
                            size="small"
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_vehicle_label_number",
                            )}
                            variant="outlined"
                            name="nchassis"
                            value={value.nchassis}
                            onChange={(event) =>
                              handleChangeChassis(index, event)
                            }
                            error={
                              !chassisErrors[index]
                                ? false
                                : chassisErrors[index].nchassis
                            }
                          ></TextField>
                          <FormHelperText error>
                            {!chassisHelpers[index]
                              ? null
                              : chassisHelpers[index].nchassis}
                          </FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={9} sm={6} md={3}>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <Autocomplete
                            name="modele"
                            size="small"
                            value={value.modele}
                            open={openM[index]}
                            onOpen={() => {
                              let o = [...openM];

                              o[index] = true;
                              setOpenM(o);
                            }}
                            onClose={() => {
                              let o = [...openM];
                              o[index] = false;
                              setOpenM(o);
                              setModeles([]);
                            }}
                            required
                            loading={loadingM}
                            loadingText={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_cargo_label_searching",
                            )}
                            onChange={(event, newValue) =>
                              handleAutoCompleteChangeM(index, event, newValue)
                            }
                            filterOptions={(options, params) => {
                              if (!loadingM) {
                                const filtered = filter(options, params);

                                return filtered;
                              } else {
                                return [];
                              }
                            }}
                            id="free-solo-with-text-demo"
                            options={modeles}
                            getOptionLabel={(option) => {
                              // Value selected with enter, right from the input
                              if (typeof option === "string") {
                                return option;
                              }
                              // Add "xxx" option created dynamically
                              if (option.inputValue) {
                                return option.text;
                              }
                              // Regular option

                              return option.name + ", " + option.brand.name;
                            }}
                            // renderOption={(option) => option.name}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                {...params}
                                label={formatMessage(
                                  intl,
                                  "create_besc_maritime_import_accordion_cargo_card_vehicle_label_model",
                                )}
                                variant="outlined"
                                required
                                onChange={(event) => {
                                  event.persist(event);
                                  if (event.target.value.length > 1) {
                                    if (!fetching) {
                                      setFetching(true);
                                    }

                                    debounceLoadModeles(event.target.value);
                                  }
                                }}
                              />
                            )}
                          ></Autocomplete>
                        </FormControl>
                      </Grid>

                      <FileUpload
                        fileSizeLimit={1 * 1048576}
                        name={"name"}
                        label={formatMessage(
                          intl,
                          "create_besc_maritime_import_accordion_cargo_card_vehicle_label_gray",
                        )}
                        id={"-vehicle-" + index}
                        index={index}
                        required={false}
                        size={3}
                        init={init[index]}
                        sendFile={(_file) => {
                          setFile(_file);
                        }}
                        onChange={() => {
                          console.log("changed");
                        }}
                      />

                      <Grid
                        item
                        xs={3}
                        alignContent="center"
                        alignItems="center"
                      >
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            size="small"
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_vehicle_label_year",
                            )}
                            name="annee"
                            value={value.annee}
                            type="date"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(event) =>
                              handleChangeChassis(index, event)
                            }
                          ></TextField>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl
                          fullWidth
                          className={classes.margin}
                          variant="outlined"
                        >
                          <TextField
                            className="m-2"
                            size="small"
                            id="outlined-select-currency"
                            label={formatMessage(
                              intl,
                              "create_besc_maritime_import_accordion_cargo_card_vehicle_label_content",
                            )}
                            name="contenu"
                            value={value.contenu}
                            multiline
                            variant="outlined"
                            onChange={(event) =>
                              handleChangeChassis(index, event)
                            }
                          ></TextField>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
            </Card>
          )}
      </form>
    </>
  );
}
